import { useEffect } from "react";
import { DisclaimerStrip } from "../components/home/DisclaimerStrip";
import { FaqSection } from "../components/home/FaqSection";
import { FinalCtaSection } from "../components/home/FinalCtaSection";
import { HeroSection } from "../components/home/HeroSection";
import { HowItWorksSection } from "../components/home/HowItWorksSection";
import { RetestNotificationSection } from "../components/home/RetestNotificationSection";
import { TrustSection } from "../components/home/TrustSection";

export function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <HeroSection />
      <HowItWorksSection />
      <TrustSection />
      <FaqSection />
      <RetestNotificationSection />
      <FinalCtaSection />
      <DisclaimerStrip />
    </>
  );
}
